import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDataConsumerContext } from "../../contexts/dataConsumerContext";

export function DataConsumerIntegrationRedirect() {
  const history = useHistory();
  const { currentDataConsumer } = useDataConsumerContext();

  const dataConsumerId = currentDataConsumer?.id;

  useEffect(() => {
    if (dataConsumerId) {
      history.push(`/integrations/${dataConsumerId}`);
    }
  }, [dataConsumerId, history]);

  return null;
}
